<template>
  <div class="container mx-auto h-full py-5">
    <el-dialog title="Vista previa" :visible.sync="userPreview" width="700px">
      <el-row :gutter="15" class="flex items-center justify-center">
        <el-col :span="5" class="flex items-center justify-center">
          -
        </el-col>
        <el-col :span="19">
          <el-row :gutter="15">
            <el-col :span="24">
              <span class="font-semibold uppercase"
                >Información de usuario</span
              >
            </el-col>
          </el-row>
          <el-row :gutter="15" class="my-2 flex items-center justify-center">
            <el-col :span="14" class="flex flex-col justify-center">
              <span class="font-semibold">Nombre:</span>
              <span>
                -
              </span>
            </el-col>
            <el-col :span="10" class="flex flex-col justify-center">
              <span class="font-semibold">Correo:</span>
              <span>{{ tempUser !== null ? tempUser.email : "" }}</span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mt-5">
        <el-col :span="24">
          <span class="font-semibold uppercase">Información personal</span>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mt-2">
        <el-col :span="12" class="flex flex-col">
          <span class="font-semibold">Dirección 1:</span>
          <span>{{ tempUser !== null ? tempUser.employee.address1 : "" }}</span>
        </el-col>
        <el-col :span="12" class="flex flex-col">
          <span class="font-semibold">Dirección 2:</span>
          <span>{{ tempUser !== null ? tempUser.employee.address2 : "" }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mt-2">
        <el-col :span="8" class="flex flex-col">
          <span class="font-semibold">País:</span>
          <span>{{
            tempUser !== null ? tempUser.employee.country.name : ""
          }}</span>
        </el-col>
        <el-col :span="8" class="flex flex-col">
          <span class="font-semibold">Departamento:</span>
          <span>{{
            tempUser !== null ? tempUser.employee.state.name : ""
          }}</span>
        </el-col>
        <el-col :span="8" class="flex flex-col">
          <span class="font-semibold">Municipio:</span>
          <span>{{
            tempUser !== null ? tempUser.employee.city.name : ""
          }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="15" class="mt-2">
        <el-col :span="8" class="flex flex-col">
          <span class="font-semibold">Correo personal:</span>
          <span>{{ tempUser !== null ? tempUser.employee.email : "" }}</span>
        </el-col>
        <el-col :span="5" class="flex flex-col">
          <span class="font-semibold">Teléfono:</span>
          <span>{{ tempUser !== null ? tempUser.employee.phone : "" }}</span>
        </el-col>
        <el-col :span="5" class="flex flex-col">
          <span class="font-semibold">Celular:</span>
          <span>{{
            tempUser !== null ? tempUser.employee.cellphone : ""
          }}</span>
        </el-col>
        <el-col :span="6" class="flex flex-col">
          <span class="font-semibold">Sexo:</span>
          <span>{{
            tempUser !== null && tempUser.employee.sex === 1
              ? "Hombre"
              : "Mujer"
          }}</span>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="userPreview = false">Cerrar</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Reiniciar contraseña"
      :visible.sync="showResetPassword"
      width="400px"
    >
      <el-form
        :model="resetPasswordForm"
        status-icon
        :rules="resetPasswordFormRules"
        ref="resetPassword"
        @submit.native.prevent="
          submitNewPassword('resetPassword', resetPasswordForm, tempUserId)
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nueva contraseña" prop="newPassword">
                  <el-input
                    placeholder="Nueva contraseña"
                    v-model="resetPasswordForm.newPassword"
                    size="small"
                    :disabled="generatePass"
                  >
                    
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showResetPassword = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Cambiar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="Actualizar correo"
      :visible.sync="showUpdateEmail"
      width="400px"
    >
      <el-form
        :model="updateEmailForm"
        status-icon
        :rules="updateEmailFormRules"
        ref="updateEmail"
        @submit.native.prevent="
          submitEmailChange('updateEmail', updateEmailForm, tempUserId)
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nuevo correo electrónico" prop="newEmail">
                  <el-input
                    placeholder="Correo electronico"
                    v-model="updateEmailForm.newEmail"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showUpdateEmail = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Actualizar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="Cambiar perfil"
      :visible.sync="showChangeProfile"
      width="400px"
    >
      <el-form
        :model="changeProfileForm"
        status-icon
        :rules="changeProfileFormRules"
        ref="changeProfile"
        @submit.native.prevent="
          submitProfileChange('changeProfile', changeProfileForm, tempUserId)
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Seleccionar perfil" prop="newEmail">
                  <el-select
                    v-model="changeProfileForm.newProfile"
                    placeholder="Select"
                    class="w-full"
                    size="small"
                  >
                    <el-option
                      v-for="p in profiles"
                      :key="p.id"
                      :label="p.name"
                      :value="p.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showChangeProfile = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Actualizar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="Nuevo usuario"
      :visible.sync="newUserDialog"
      width="700px"
    >
      <el-form
        :model="newUserForm"
        status-icon
        :rules="newUserFormRules"
        ref="newUserForm"
        @submit.native.prevent="saveNewUser('newUserForm', newUserForm)"
      >
      
        <el-row :gutter="15" class="mt-5">
          <el-col :span="24">
            <span class="font-semibold uppercase">Información de usuario</span>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="14">
            <el-form-item
              label="Ingrese los nombres"
              prop="text"
              class="mb-4"
            >
              <el-input
                placeholder="Nombres"
                v-model="newUserForm.names"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              label="Ingrese los apellidos"
              prop="text"
              class="mb-4"
            >
              <el-input
                placeholder="Apellidos"
                v-model="newUserForm.lastnames"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item
              label="Usuario para inicio de sesión"
              prop="email"
              class="mb-4"
            >
              <el-input
                placeholder="Correo electrónico"
                v-model="newUserForm.email"
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Administrador" prop="admin" class="mb-4">
              <el-select
                v-model="newUserForm.admin"
                placeholder="Es adminsitrador?"
                class="w-full"
                size="small"
              >
                <el-option label="Si" :value="true" />
                <el-option label="No" :value="false" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="14">
            <el-form-item label="Nueva contraseña" prop="password" class="mb-4">
              <el-input
                placeholder="Contraseña"
                v-model="newUserForm.password"
                size="small"
                :disabled="generatePass"
              >
                
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Estado" prop="status" class="mb-4">
              <el-select
                v-model="newUserForm.status"
                placeholder="Seleccionar estado"
                class="w-full"
                size="small"
              >
                <el-option label="Activo" :value="true" />
                <el-option label="Inactivo" :value="false" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="flex justify-end mb-0 mt-5">
          <el-button size="small" @click="newUserDialog = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-row :gutter="15" type="flex" justify="center">
      <el-col :span="24">
        <el-row :gutter="15">
          <el-col :span="24">
            <h3 class="text-l font-semibold">USUARIOS</h3>
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="space-between" class="my-5">
          <el-col :span="5">
            <el-button
              type="primary"
              size="small"
              @click.native="openNewUserDialog('newUserForm')"
              :loading="newUserLoading"
              >Nuevo usuario</el-button
            >
          </el-col>
          <el-col :span="5">
            <el-input
              placeholder="Buscar"
              v-model="searchValue"
              size="small"
              suffix-icon="el-icon-search"
            />
          </el-col>
        </el-row>


        <el-row :gutter="15">
          <el-col :span="24">
            <el-table :data="filteredUsers" stripe size="mini">
              <el-table-column type="index" label="#" min-width="50" />

              <el-table-column label="Nombre" min-width="250" align="left">
                <template slot-scope="scope">
<span>{{ scope.row.names }} {{ scope.row.lastnames}}</span> 
                </template>
              </el-table-column>
              <el-table-column prop="email" label="Correo" min-width="200" />
              <el-table-column label="Estado" min-width="100" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.isActive">
                    <el-tag type="success" size="small">Activo</el-tag>
                  </span>
                  <span v-else>
                    <el-tag type="warning" size="small">Inactivo</el-tag>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="Administrador" min-width="100" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.super">
                    <el-tag type="success" size="small">Si</el-tag>
                  </span>
                  <span v-else>
                    <el-tag type="warning" size="small">No</el-tag>
                  </span>
                </template>
              </el-table-column>
             
              <el-table-column prop="address" min-width="80" align="center">
                <template slot-scope="scope">
                  <el-dropdown trigger="click">
                    <el-button
                      icon="el-icon-fa-ellipsis-v"
                      size="small"
                    ></el-button>
                    <el-dropdown-menu slot="dropdown">                    
                      <el-dropdown-item
                        @click.native="resetPassword(scope.row)"
                      >
                        <i class="el-icon-fa-refresh"></i> Reiniciar contraseña
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="changeStatus(scope.row)">
                        <span v-if="scope.row.isActive">
                          <i class="el-icon-fa-times"></i> Desactivar
                        </span>
                        <span v-else>
                          <i class="el-icon-fa-check"></i> Activar
                        </span>
                        usuario
                      </el-dropdown-item>
                      <el-dropdown-item
                        :divided="true"
                        class="text-red-500 font-semibold"
                        @click.native="deleteUser(scope.row)"
                      >
                        <i class="el-icon-fa-trash"></i> Eliminar
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>


        
        <el-row :gutter="15" type="flex" justify="end" class="mt-5">
          <el-pagination
            small
            @size-change="handleSizeChange"
            :current-page.sync="page.number"
            :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="rawUsers.length"
            :pager-count="5"
          />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import { constants } from "fs";
import * as R from "ramda";

export default {
  name: "SettingsUser",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{ users { id email names lastnames isActive super } }`,
      })
      .then((res) => {
          const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) => vm.setData(data.users));
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    var validateExistUser = (rule, value, callback) => {
        if (value === '1234') {
          callback(new Error('el valor no es 1234'));
        } 
        callback();
      };
    return {
      userPreview: false,
      searchValue: "",
      tempUserId: null,
      tempUser: null,
      tempEmployee: null,
      showResetPassword: false,
      generatePass: false,
      resetPasswordForm: {
        newPassword: "",
      },
      resetPasswordFormRules: {
        newPassword: [
          {
            required: true,
            message: "Debes agregar una nueva contraseña",
            trigger: "blur",
          },
        ],
      },
      newUserForm: {
        employee: "",
        names: "",
        lastnames: "",
        email: "",
        password: "",
        password: "",
        admin: "",
        status: true,
      },
      newUserFormRules: {
        employee: [
          {
            required: true,
            message: "Debes seleccionar un usuario",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "Debes agregar una contraseña al usuario",
            trigger: "blur",
          },
          ,          
          {
            validator: validateExistUser,
            message: "Debes si es o no administrador",
            trigger: "blur",
          }
          /*{
            type: "email",
            message: "Debes agregar un correo válido",
            trigger: ["blur", "change"],
          },*/
        ],
        password: [
          {
            required: true,
            message: "Debes agregar una contraseña",
            trigger: "blur",
          },
        ],
        names: [
          {
            required: true,
            message: "Debe ingresar sus nombres",
            trigger: "blur",
          },
        ],
        lastnames: [
          {
            required: true,
            message: "Debe ingresar sus apellidos",
            trigger: "blur",
          },
        ],
        admin: [
          {
            required: true,
            message: "Debes si es o no administrador",
            trigger: "blur",
          }
        ],
        status: [
          {
            required: true,
            message: "Debes seleccionar un estado",
            trigger: "blur",
          },
        ],
      },
      newUserDialog: false,
      newUserLoading: false,
      page: {
        size: 5,
        number: 1,
      },
      rawUsers: [],
      employees: [],
      profiles: [],
      showUpdateEmail: false,
      updateEmailForm: {
        newEmail: "",
      },
      updateEmailFormRules: {
        newEmail: [
          {
            required: true,
            message: "Debes agregar un correo electrónico",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Debes agregar un correo válido",
            trigger: ["blur", "change"],
          },
        ],
      },
      showChangeProfile: false,
      changeProfileForm: {
        newProfile: "",
      },
      changeProfileFormRules: {
        newProfile: [
          {
            required: true,
            message: "Debes seleccionar un perfil",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
      handleSizeChange(val) {
      this.page.size = val;
    },
    setData(data) {
      this.rawUsers = data;
    },
    changeStatus(user) {
      const action = user.isActive ? "desactivar" : "activar";
      const message = `¿Estás seguro que deseas ${action} este usuario?`;
      const saveText = `Si, proceder`;
      this.$confirm(message, "Confirmación", {
        confirmButtonText: "Si, actualizar",
        cancelButtonText: "Cancelar",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "Procesando...";
            axios
              .post("/", {
                query: `
                mutation { 
                  userUpdateStatus
                  ( where: { id: "${user.id}" } isActive: ${!user.isActive} )
                  {  id email names lastnames isActive super  }
                }`,
              })
              .then((res) => {
                const { data, errors } = res.data;
                if (R.isNil(errors)) {
                  this.rawUsers = data.userUpdateStatus;
                }
                this.$notify({
                  title: R.isNil(errors) ? "Éxito" : "Error",
                  message: R.isNil(errors)
                    ? "Se ha cambiado el estado correctamente"
                    : errors[0].message,
                  type: R.isNil(errors) ? "success" : "error",
                  duration: 3500,
                });
                instance.confirmButtonLoading = false;
                instance.confirmButtonText = "Si, actualizar";
                done();
              });
          } else {
            done();
          }
        },
      });
    },
    
    resetPassword(user) {
      this.tempUserId = user.id;
      this.showResetPassword = true;
      this.newPassword = "";
      this.generatePass = false;
      const ref = this.$refs["resetPassword"];
      if (!R.isNil(ref)) {
        ref.resetFields();
      }
    },
    submitNewPassword(formName, { newPassword }, id) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.$confirm(
          "¿Estás seguro que deseas reiniciar la contraseña para este usuario?",
          "Confirmación",
          {
            confirmButtonText: "Si, reiniciar",
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                axios
                  .post("/", {
                    query: `mutation { userUpdatePassword(where: { id: "${id}" } password: "${newPassword}") {
                    id email isActive super 
                  } }`,
                  })
                  .then((res) => {
                    const { data, errors } = res;
                    if (R.isNil(errors)) {
                      this.rawUsers = res.data.data.userUpdatePassword;
                    }
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? "Se ha actualizado la contraseña correctamente"
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    this.showResetPassword = false;
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = "Si, reiniciar";
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
    saveNewUser(formName, { names, lastnames, email, password, admin, status }) {
      
      if(this.rawUsers.find(d=> d.email==email.toLowerCase().trim())){
        this.$notify({
          title: 'Usuario existente',
          message: 'El usuario que desea crear ya existe. Cambie el nombre del usuario',
          type: 'warning'
        });
        return false;

      }


      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.$confirm(
          "¿Estás seguro que deseas crear este nuevo usuario?",
          "Confirmación",
          {
            confirmButtonText: "Si, crear",
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                axios
                  .post("/", {
                    query: `mutation {
                      userSave
                      ( data: { email: "${email}", password: "${password}", isActive: ${status}, super: ${admin}, names: "${names}", lastnames: "${lastnames}" } )
                      { id email names lastnames isActive super }
                    }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    if (!R.isNil(data)) {
                      this.rawUsers = data.userSave;
                    }
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? "Se ha creado el usuario correctamente"
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    this.showResetPassword = false;
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = "Si, crear";
                    this.newUserDialog = false;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
        deleteUser({ id }) {
      this.$confirm(
        "¿Estás seguro que deseas eliminar este usuario?",
        "Confirmación",
        {
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation { userDelete( where: {id: "${id}"} ) { id email names lastnames isActive super } }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.rawUsers = data.userDelete;
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha eliminado el usuario correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, eliminar";
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    openNewUserDialog(formName) {
      //this.newUserLoading = true;
      this.newUserDialog = true;
      
    },
  },
  computed: {
      fullName(){
          return "peco peco";

      },
    filteredUsers() {
      return this.rawUsers
        .filter((user) => {
          return (           
            user.email.toLowerCase().includes(this.searchValue.toLowerCase())
          );
        })
        .slice(
          this.page.number * this.page.size - this.page.size,
          this.page.size * this.page.number
        );
    },
  },
};
</script>
